module.exports = __webpack_public_path__ + "img/sensei_logo.d9ffa8d0.png";